//绿云PMS
export const greenCloudRouter = [
  {
    path: '/service/greenCloudPMS/productList',
    name: 'PMSProductList',
    component: () => import('@/views/service/serviceProvider/greenCloudPMS/ProductList'),
    meta: {
      title: '同步产品',
      keepAlive: false
    }
  },
  {
    path: '/service/greenCloudPMS/directOrdersList',
    name: 'PMSDirectOrdersList',
    component: () => import('@/views/service/serviceProvider/greenCloudPMS/DirectOrdersList'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/greenCloudPMS/associatedAccount',
    name: 'PMSAssociatedAccount',
    component: () => import('@/views/service/serviceProvider/greenCloudPMS/AssociatedAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/greenCloudPMS/synchronizationRules',
    name: 'PMSSynchronizationRules',
    component: () => import('@/views/service/serviceProvider/greenCloudPMS/SynchronizationRules'),
    meta: {
      title: '同步规则',
      keepAlive: false
    }
  }
]